import { Component, DoCheck, Inject, Input, Output, EventEmitter } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';

import { AnswerEngineOption } from '../../models/answer-engine-option.model';
import { AnswerEngineTypesEnum } from '../../enums/answer-engine-types.enum';

@Component({
    selector: 'agpr-vi-engine-selector',
    templateUrl: './vi-engine-selector.component.html',
    styleUrls: ['./vi-engine-selector.component.scss'],
    standalone: false
})
export class ViEngineSelectorComponent implements DoCheck {
    @Input() id: string = 'agpr_viEngineSelector';
    @Input() engines: AnswerEngineOption[] = [];
    @Input() selectedType: AnswerEngineTypesEnum | null = null;
    /** Shows an extra "All Engines" option ahead of the individual engines. Selecting it reports a null selectedType. */
    @Input() showAllEnginesOption: boolean = false;

    @Output() selectedTypeChange = new EventEmitter<AnswerEngineTypesEnum | null>();

    isAllSelected: boolean = false;
    selectedEngine: AnswerEngineOption | undefined;
    isLoading: boolean = false;
    isAnyEngineLoading: boolean = false;
    isAllUnavailable: boolean = false;

    constructor(@Inject(APP_BASE_HREF) public appBaseHref: string) {}

    // engines' loading/answerText are mutated in place by callers, so reference-based ngOnChanges can't catch updates
    ngDoCheck(): void {
        this.isAllSelected = this.showAllEnginesOption && this.selectedType === null;
        this.selectedEngine = this.isAllSelected
            ? undefined
            : this.engines.find(engine => engine.type === this.selectedType) ?? this.engines[0];
        this.isAnyEngineLoading = this.engines.some(engine => engine.loading);
        this.isLoading = this.isAllSelected ? this.isAnyEngineLoading : (!this.selectedEngine || !!this.selectedEngine.loading);
        this.isAllUnavailable = this.engines.length > 0 && this.engines.every(engine => !engine.answerText && !engine.loading);
    }

    select(engineType: AnswerEngineTypesEnum | null): void {
        if (engineType === this.selectedType) {
            return;
        }
        this.selectedTypeChange.emit(engineType);
    }
}
